'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();

import type React from 'react';
import { useState } from 'react';
import { usePermissions } from '@/hooks/use-permission';

interface FeatureLockGate {
  /** True when the user lacks the required permission. */
  isLocked: boolean;
  /**
   * Wrap an onClick action. If the feature is locked, opens the dialog instead.
   * Otherwise calls the action.
   */
  guard: (action: () => void) => void;
  /**
   * Use as an onClick on a <Link>. Calls preventDefault and opens the dialog
   * when locked. Returns true if it blocked navigation.
   */
  guardNavigation: (event: React.MouseEvent) => boolean;
  /** Spread these onto <FeatureLockedDialog />. */
  featureLockedDialogProps: {
    open: boolean;
    onOpenChange: (open: boolean) => void;
  };
}

/**
 * Gates a premium action behind a permission check.
 * When the user lacks `requiredPermission`, interactions open the Feature Locked dialog.
 */
export function useFeatureLockGate(requiredPermission: string): FeatureLockGate {
  const [open, setOpen] = useState(false);
  const { hasPermission } = usePermissions();

  const isLocked = !hasPermission(requiredPermission);

  const guard = (action: () => void) => {
    if (isLocked) {
      setOpen(true);
    } else {
      action();
    }
  };

  const guardNavigation = (event: React.MouseEvent): boolean => {
    if (isLocked) {
      event.preventDefault();
      setOpen(true);
      return true;
    }
    return false;
  };

  return {
    isLocked,
    guard,
    guardNavigation,
    featureLockedDialogProps: {
      open,
      onOpenChange: setOpen,
    },
  };
}
